import { safeGetStorageItem, safeRemoveStorageItem, safeSetStorageItem } from './browserStorage';

const HIGH_RISK_STEP_UP_ACTION_STORAGE_KEY = 'botspot.highRiskStepUpAction';
const HIGH_RISK_STEP_UP_ACTION_MAX_AGE_MS = 30 * 60 * 1000;
const ACTION_ID_PATTERN = /^[a-zA-Z0-9_-]{1,100}$/;

export const normalizeHighRiskStepUpActionId = (value) => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return ACTION_ID_PATTERN.test(trimmed) ? trimmed : null;
};

export const rememberHighRiskStepUpActionId = (actionId, nowMs = Date.now()) => {
  const normalizedActionId = normalizeHighRiskStepUpActionId(actionId);
  if (!normalizedActionId) return false;

  return safeSetStorageItem(
    'sessionStorage',
    HIGH_RISK_STEP_UP_ACTION_STORAGE_KEY,
    JSON.stringify({
      actionId: normalizedActionId,
      createdAt: nowMs,
    }),
  );
};

export const readHighRiskStepUpActionId = (nowMs = Date.now()) => {
  const rawValue = safeGetStorageItem('sessionStorage', HIGH_RISK_STEP_UP_ACTION_STORAGE_KEY);
  if (!rawValue) return null;

  let parsed;
  try {
    parsed = JSON.parse(rawValue);
  } catch {
    parsed = { actionId: rawValue, createdAt: nowMs };
  }

  const actionId = normalizeHighRiskStepUpActionId(parsed?.actionId);
  const createdAt = Number(parsed?.createdAt);
  if (
    !actionId ||
    !Number.isFinite(createdAt) ||
    nowMs - createdAt > HIGH_RISK_STEP_UP_ACTION_MAX_AGE_MS
  ) {
    safeRemoveStorageItem('sessionStorage', HIGH_RISK_STEP_UP_ACTION_STORAGE_KEY);
    return null;
  }

  return actionId;
};

export const clearHighRiskStepUpActionId = (actionId) => {
  const normalizedActionId = normalizeHighRiskStepUpActionId(actionId);
  if (normalizedActionId && readHighRiskStepUpActionId() !== normalizedActionId) {
    return;
  }
  safeRemoveStorageItem('sessionStorage', HIGH_RISK_STEP_UP_ACTION_STORAGE_KEY);
};

// Routing intent only. The existing BotSpot JWT supplies the account proof;
// provider grants and credentials are never copied into this storage key.
const SECURITY_REAUTH_INTENT_KEY = 'botspot.securityReauthUntil';
export const rememberSecurityReauthIntent = (nowMs = Date.now()) =>
  safeSetStorageItem('sessionStorage', SECURITY_REAUTH_INTENT_KEY, String(nowMs + 5 * 60_000));
export const clearSecurityReauthIntent = () =>
  safeRemoveStorageItem('sessionStorage', SECURITY_REAUTH_INTENT_KEY);
export const readSecurityReauthIntent = (nowMs = Date.now()) => {
  const expiresAt = Number(safeGetStorageItem('sessionStorage', SECURITY_REAUTH_INTENT_KEY));
  if (!Number.isFinite(expiresAt) || expiresAt <= nowMs || expiresAt > nowMs + 5 * 60_000) {
    clearSecurityReauthIntent();
    return false;
  }
  return true;
};
